<div class="aca-admin aca-work">
  <aca-page-header icon="inbox" [title]="'DMS.MYWORK.TITLE' | translate" [subtitle]="'DMS.MYWORK.SUBTITLE' | translate">
    <button type="button" class="aca-work__outline" (click)="reload()" [disabled]="loading() || working()">
      <mat-icon>refresh</mat-icon>{{ 'DMS.MYWORK.REFRESH' | translate }}
    </button>
  </aca-page-header>

  <!-- intro banner — dismissible, stays dismissed -->
  <section class="aca-work__banner" *ngIf="bannerOn()">
    <span class="aca-work__bicon"><mat-icon>check</mat-icon></span>
    <div class="aca-work__btext">
      <strong>{{ 'DMS.MYWORK.BANNER_TITLE' | translate }}</strong>
      <span>{{ 'DMS.MYWORK.BANNER_TEXT' | translate }}</span>
    </div>
    <button type="button" class="aca-work__bx" [attr.aria-label]="'DMS.MYWORK.BANNER_DISMISS' | translate" (click)="dismissBanner()">
      <mat-icon>close</mat-icon>
    </button>
  </section>

  <!-- tabs with counters -->
  <div class="aca-work__tabs" role="tablist">
    <button
      *ngFor="let t of tabs"
      type="button"
      role="tab"
      class="aca-work__tab"
      [class.aca-work__tab--on]="tab() === t.id"
      [attr.aria-selected]="tab() === t.id"
      (click)="switchTab(t.id)"
    >
      {{ t.key | translate }}
      <span class="aca-work__count">{{ loading() ? '–' : countFor(t.id) }}</span>
    </button>
  </div>

  <!-- search + filters -->
  <div class="aca-work__filters">
    <label class="aca-work__search">
      <mat-icon>search</mat-icon>
      <input type="search" [(ngModel)]="search" (ngModelChange)="resetPage()" [placeholder]="'DMS.MYWORK.SEARCH' | translate" />
    </label>
    <select
      class="aca-work__select"
      [(ngModel)]="filterWorkflow"
      (ngModelChange)="resetPage()"
      [attr.aria-label]="'DMS.MYWORK.F_WORKFLOW' | translate"
    >
      <option value="">{{ 'DMS.MYWORK.O_WORKFLOW' | translate }}</option>
      <option *ngFor="let w of workflows()" [value]="w">{{ w }}</option>
    </select>
    <select class="aca-work__select" [(ngModel)]="filterKind" (ngModelChange)="resetPage()" [attr.aria-label]="'DMS.MYWORK.F_KIND' | translate">
      <option value="">{{ 'DMS.MYWORK.O_KIND' | translate }}</option>
      <option value="approve">{{ 'DMS.MYWORK.KIND_APPROVE' | translate }}</option>
      <option value="review">{{ 'DMS.MYWORK.KIND_REVIEW' | translate }}</option>
      <option value="task">{{ 'DMS.MYWORK.KIND_TASK' | translate }}</option>
    </select>
    <select class="aca-work__select" [(ngModel)]="filterState" (ngModelChange)="resetPage()" [attr.aria-label]="'DMS.MYWORK.F_STATE' | translate">
      <option value="">{{ 'DMS.MYWORK.O_STATE' | translate }}</option>
      <option value="open">{{ 'DMS.MYWORK.STATE_OPEN' | translate }}</option>
      <option value="pooled">{{ 'DMS.MYWORK.STATE_POOLED' | translate }}</option>
      <option value="running">{{ 'DMS.MYWORK.STATE_RUNNING' | translate }}</option>
      <option value="done">{{ 'DMS.MYWORK.STATE_DONE' | translate }}</option>
    </select>
    <span class="aca-work__flex"></span>
    <button type="button" class="aca-work__morebtn" [class.aca-work__morebtn--on]="moreOpen()" (click)="moreOpen.set(!moreOpen())">
      <mat-icon>filter_list</mat-icon>{{ 'DMS.MYWORK.MORE_FILTERS' | translate }}
    </button>
  </div>

  <!-- folded filters: due date + priority -->
  <div class="aca-work__xtra" *ngIf="moreOpen()">
    <select class="aca-work__select" [(ngModel)]="filterDue" (ngModelChange)="resetPage()" [attr.aria-label]="'DMS.MYWORK.F_DUE' | translate">
      <option value="">{{ 'DMS.MYWORK.O_DUE' | translate }}</option>
      <option value="overdue">{{ 'DMS.MYWORK.DUE_OVERDUE' | translate }}</option>
      <option value="week">{{ 'DMS.MYWORK.DUE_WEEK' | translate }}</option>
    </select>
    <select
      class="aca-work__select"
      [(ngModel)]="filterPriority"
      (ngModelChange)="resetPage()"
      [attr.aria-label]="'DMS.MYWORK.F_PRIORITY' | translate"
    >
      <option value="">{{ 'DMS.MYWORK.O_PRIORITY' | translate }}</option>
      <option value="1">{{ 'DMS.MYWORK.P_HIGH' | translate }}</option>
      <option value="2">{{ 'DMS.MYWORK.P_MEDIUM' | translate }}</option>
      <option value="3">{{ 'DMS.MYWORK.P_LOW' | translate }}</option>
    </select>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading() || working()" />

  <aca-page-state
    *ngIf="!loading() && loadFailed()"
    state="error"
    icon="cloud_off"
    [title]="'DMS.MYWORK.LOAD_FAILED' | translate"
    [message]="'DMS.MYWORK.LOAD_FAILED_HINT' | translate"
  />

  <p class="aca-work__partial" *ngIf="!loading() && partsMissing().length" role="status">
    <mat-icon>cloud_off</mat-icon>
    <span
      >{{ 'DMS.MYWORK.PART_MISSING' | translate }}
      <ng-container *ngFor="let part of partsMissing(); let last = last"
        >{{ 'DMS.MYWORK.PART_' + (part | uppercase) | translate }}{{ last ? '' : ', ' }}</ng-container
      ></span
    >
  </p>

  <aca-page-state
    *ngIf="!loading() && !loadFailed() && !visible().length"
    state="empty"
    icon="task_alt"
    [title]="'DMS.MYWORK.EMPTY_TITLE' | translate"
    [message]="'DMS.MYWORK.EMPTY_HINT' | translate"
  />

  <!-- table -->
  <section class="aca-work__card" *ngIf="visible().length">
    <div class="aca-work__scroll">
      <table class="aca-work__table">
        <thead>
          <tr>
            <th class="aca-work__colsel">
              <mat-checkbox [checked]="allSel()" [attr.aria-label]="'DMS.MYWORK.SEL_ALL' | translate" (change)="toggleAllSel($event.checked)" />
            </th>
            <th>{{ 'DMS.MYWORK.COL_DOC' | translate }}</th>
            <th>{{ 'DMS.MYWORK.COL_WORKFLOW' | translate }}</th>
            <th>{{ 'DMS.MYWORK.COL_STEP' | translate }}</th>
            <th>{{ 'DMS.MYWORK.COL_KIND' | translate }}</th>
            <th class="aca-work__thsort" (click)="toggleDueSort()">
              {{ 'DMS.MYWORK.COL_DUE' | translate }}
              <mat-icon>{{ sortDue() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
            </th>
            <th>{{ 'DMS.MYWORK.COL_STATE' | translate }}</th>
            <th class="aca-work__col-actions">{{ 'DMS.MYWORK.COL_ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of paged()" class="aca-work__row" [class.aca-work__row--sel]="isSel(r)" (click)="openRow(r)">
            <td class="aca-work__colsel" (click)="$event.stopPropagation()">
              <mat-checkbox [checked]="isSel(r)" [attr.aria-label]="'DMS.MYWORK.SEL_ROW' | translate" (change)="toggleSel(r, $event.checked)" />
            </td>
            <td>
              <span class="aca-work__doc">
                <span class="aca-work__file" [ngClass]="fileClass(r)"
                  ><mat-icon>{{ fileIcon(r) }}</mat-icon></span
                >
                <span class="aca-work__docmain">
                  <span class="aca-work__docname">{{ r.docName || r.name }}</span>
                  <span class="aca-work__docsub">{{ docSub(r) }}</span>
                </span>
              </span>
            </td>
            <td class="aca-work__cell-wf">
              <span class="aca-work__wfname">{{ wfName(r) }}</span>
              <span class="aca-work__wfsub" *ngIf="wfSub(r)">{{ wfSub(r) }}</span>
            </td>
            <td>{{ r.step | translate }}</td>
            <td>
              <span class="aca-work__chip" [ngClass]="'aca-work__chip--' + kind(r)">{{ kindLabel(r) | translate }}</span>
            </td>
            <td>
              <ng-container [ngSwitch]="dueMode(r)">
                <span class="aca-work__duecell" *ngSwitchCase="'today'">
                  {{ 'DMS.MYWORK.DUE_TODAY' | translate }} {{ r.dueAt | acaDate: 'HH:mm' }}
                  <small class="aca-work__duesub aca-work__duesub--warn">{{
                    dueLeftHours(r) <= 1
                      ? ('DMS.MYWORK.DUE_LEFT_M' | translate: { p0: dueLeftMin(r) })
                      : ('DMS.MYWORK.DUE_LEFT_H' | translate: { p0: dueLeftHours(r) })
                  }}</small>
                </span>
                <span class="aca-work__duecell" *ngSwitchCase="'tomorrow'">
                  {{ 'DMS.MYWORK.DUE_TOMORROW' | translate }}
                  <small class="aca-work__duesub">{{ r.dueAt | acaDate: 'd MMM y' }}</small>
                </span>
                <span class="aca-work__duecell" *ngSwitchCase="'week'">
                  {{ r.dueAt | acaDate: 'd MMM y' }}
                  <small class="aca-work__duesub">{{ 'DMS.MYWORK.DUE_LEFT_D' | translate: { p0: dueLeftDays(r) } }}</small>
                </span>
                <span class="aca-work__duecell" *ngSwitchCase="'over'">
                  {{ r.dueAt | acaDate: 'd MMM y' }}
                  <small class="aca-work__duesub aca-work__duesub--late">{{ 'DMS.MYWORK.DUE_OVERDUE' | translate }}</small>
                </span>
                <span class="aca-work__duecell" *ngSwitchCase="'date'">{{ r.dueAt | acaDate: 'd MMM y' }}</span>
                <span *ngSwitchCase="'none'">—</span>
              </ng-container>
            </td>
            <td>
              <span class="aca-work__chip aca-work__chip--icon" [ngClass]="'aca-work__chip--' + chipKey(r)">
                <mat-icon>{{ chipIcon(r) }}</mat-icon
                >{{
                  chipKey(r) === 'overdue' ? ('DMS.MYWORK.DUE_OVERDUE' | translate) : ('DMS.MYWORK.STATE_' + stateKey(r).toUpperCase() | translate)
                }}
              </span>
            </td>
            <td class="aca-work__col-actions">
              <button type="button" class="aca-work__openbtn" (click)="openRow(r); $event.stopPropagation()">
                {{ 'DMS.MYWORK.OPEN' | translate }}
              </button>
              <button
                mat-icon-button
                type="button"
                class="aca-work__kebab"
                data-automation-id="dms-work-menu"
                [attr.aria-label]="'DMS.MYWORK.MENU' | translate"
                [matMenuTriggerFor]="workMenu"
                (click)="$event.stopPropagation()"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #workMenu="matMenu">
                <button
                  mat-menu-item
                  type="button"
                  data-automation-id="dms-work-claim"
                  *ngIf="claimable(r)"
                  [disabled]="working()"
                  (click)="claim(r, $event)"
                >
                  <mat-icon>pan_tool</mat-icon>{{ 'DMS.MYWORK.CLAIM' | translate }}
                </button>
                <button mat-menu-item type="button" [disabled]="!r.docId" (click)="openDoc(r, $event)">
                  <mat-icon>visibility</mat-icon>{{ 'DMS.MYWORK.OPEN_DOC' | translate }}
                </button>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- pager -->
    <footer class="aca-work__pager">
      <span class="aca-work__range">{{ 'DMS.MYWORK.PAGE_RANGE' | translate: { p0: rangeFrom(), p1: rangeTo(), p2: visible().length } }}</span>
      <div class="aca-work__pagerctl">
        <select
          class="aca-work__select aca-work__psize"
          [(ngModel)]="pageSize"
          (ngModelChange)="resetPage()"
          [attr.aria-label]="'DMS.MYWORK.PAGE_PER' | translate"
        >
          <option *ngFor="let s of pageSizes" [ngValue]="s">
            {{ 'DMS.MYWORK.PAGE_PER' | translate: { p0: s } }}
          </option>
        </select>
        <button type="button" class="aca-work__pagebtn" [disabled]="page() <= 1" (click)="goPage(page() - 1)" aria-label="Previous page">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button *ngFor="let p of pageNums()" type="button" class="aca-work__pagebtn" [class.aca-work__pagebtn--on]="p === page()" (click)="goPage(p)">
          {{ p }}
        </button>
        <button type="button" class="aca-work__pagebtn" [disabled]="page() >= pageCount()" (click)="goPage(page() + 1)" aria-label="Next page">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </footer>
  </section>
</div>
